<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">新建充值卡金</div>
		<div class="newADcontent">
			<div class="adContent">
				<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
					<el-form-item label="名称">
						<el-input v-model="addDataList.name" size="small" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="充值金额">
						<el-input v-model="addDataList.getTotal" size="small" style="width: 200px;"
							placeholder="充值金额必须为整数"></el-input>
					</el-form-item>
					<el-form-item label="赠送内容">
						<div v-for="(item,index) in selectCoupon">
							<span style="margin-right: 2px;">券{{index+1}}</span><el-tag
								style="color: #444444;font-size: 14px;border-color: #c9cacf;">{{item.title + ':' + item.remark}}</el-tag>
						</div>
						<p><el-button @click="addCoupons = true" type="text" style="color: #999;"><i
									class="el-icon-plus"></i>添加券</el-button></p>

						<div v-for="(item,index) in selectCouponpackages">
							<span style="margin-right: 2px;">券包{{index+1}}</span><el-tag
								style="color: #444444;font-size: 14px;border-color: #c9cacf;">{{item.title + ':' + item.remark}}</el-tag>
						</div>
						<p><el-button @click="addCouponpackages = true" type="text" style="color: #999;"><i
									class="el-icon-plus"></i>添加券包</el-button></p>
						<p>添加充值金额<el-input v-model="addDataList.sendMoney" size="small" style="width: 200px;"
								placeholder="充值金额必须为整数"></el-input></p>
					</el-form-item>
					<el-form-item>
						<div
							style="background-color: #bbb;width:100%; height: 1px;margin-top: 20px;margin-bottom: 20px;">
						</div>
					</el-form-item>
					<el-form-item label="价格">
						<el-input v-model="addDataList.price" size="small" style="width: 200px;"
							placeholder="购买金额"></el-input>
					</el-form-item>
					<el-form-item label="排序">
						<el-input v-model="addDataList.orderBy" size="small" style="width: 200px;"
							placeholder="填写序号"></el-input>
					</el-form-item>
					<el-form-item label="充值说明">
						<el-input type="textarea" v-model="addDataList.content" style="width: 400px;height: 200px;"
							placeholder="本说明仅在发型师核销时,用户扫码获取充值卡金页面显示">
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="goback()">取消</el-button>
						<el-button type="primary" @click="adddeposit(1)" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- 添加券 -->
		<el-dialog title="添加券" :visible.sync="addCoupons" width="70%">
			<el-input v-model="filter.name" size="small" style="width: 200px;" placeholder="输入优惠券名称"></el-input>
			<el-button type="primary" @click="getjuan" style="margin-left: 20px;" size="small">搜索</el-button>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-checkbox-group v-model="addDataList.coupons">
					<el-table :data="quanList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id+''"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="券名称" prop="title" align="center">
						</el-table-column>
						<!-- <el-table-column prop="storeListName" align="center" label="试用范围">
						</el-table-column> -->
						<el-table-column prop="content" align="center" label="券内容">
							<template slot-scope="scope">
								<div style="height:80px; text-overflow:ellipsis;">
									<p v-html='scope.row.content'></p>
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="有效期">
							<template slot-scope="scope">
								{{scope.row.termOfValidity}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="已领取/优惠券总量">
							<template slot-scope="scope">
								{{scope.row.getNumScaleTotalNum}}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="useNum" label="已使用">
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-pagination background style="margin-top: 30px;" layout="total, prev, pager, next"
					@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="filter.page"
					:total="filter.total">
				</el-pagination>
			</div>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="addCoupons=false">取消</el-button>
					<el-button size="small" type="primary" @click="handleClick()">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加券包 -->
		<el-dialog title="添加券包" :visible.sync="addCouponpackages" width="70%">
			<el-input v-model="filter.name" size="small" style="width: 200px;" placeholder="输入券包名称"></el-input>
			<el-button type="primary" @click="getjuan" style="margin-left: 20px;" size="small">搜索</el-button>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-checkbox-group v-model="addDataList.couponpackages">
					<el-table :data="packagesList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.id+''"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="券包名称" prop="title" align="center"></el-table-column>
						<el-table-column prop="content" align="center" label="券包内容">
							<template slot-scope="scope">
								<div style="height:80px; text-overflow:ellipsis;">
									<p v-html='scope.row.content'></p>
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="有效期">
							<template slot-scope="scope">
								{{scope.row.termOfValidity}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="已领取/优惠券总量">
							<template slot-scope="scope">
								{{scope.row.getNumScaleTotalNum}}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="useNum" label="已使用">
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-pagination background style="margin-top: 30px;" layout="total, prev, pager, next"
					@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="filter.page"
					:total="filter.total">
				</el-pagination>
			</div>
			<div class="add_botom">
				<div class="add_botom_nei">
					<el-button size="small" @click="addCouponpackages=false">取消</el-button>
					<el-button size="small" type="primary" @click="handleClick()">确定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	const allCoupons = []
	export default {
		components: {
			upload
		},
		inject: ['reload'],
		data() {
			return {
				id: "",
				filter: {
					page: 1,
					size: 10,
					name: undefined,
					total: 0
				},
				addDataList: {
					id: undefined,
					name: "", //卡金套餐名称
					circulation: undefined,
					addTime: undefined, //添加时间
					orderBy: undefined, //排序
					coupons: [],
					couponpackages: [],
					price: "", //支付价格
					sendMoney: "", //赠送金额
					getTotal: "", //充值金额
					content: "", //充值说明
				},
				addCoupons: false,
				addCouponpackages: false,
				quanList: [],
				packagesList: [],
				selectCoupon: [],
				selectCouponpackages: [],
				allCoupons: []
			}
		},
		mounted() {
			this.getjuan()
			this.getCouponpackages()
			this.addDataList.id = this.$route.query.id
			// 卡金套餐  新建为什么会有BYID
			if (this.addDataList.id) {
				this.$http.get("couponPackage/getById?id=" + this.addDataList.id).then(function(res) {
					this.addDataList = JSON.parse(JSON.stringify(res.body.data));
					this.addDataList.price = this.addDataList.price / 100
					this.addDataList.name = this.addDataList.name
					this.addDataList.orderBy = this.addDataList.orderBy
					this.addDataList.sendMoney = this.addDataList.sendMoney
					this.addDataList.addTime = this.addDataList.addTime
					this.addDataList.getTotal = this.addDataList.getTotal
					this.addDataList.coupons = this.addDataList.coupons.split(",");
					this.addDataList.couponpackages = this.addDataList.couponpackages.split(",");
					this.addDataList.content = this.addDataList.content
				})
			}
			this.$http.get("dCoupon/list?pageNum=1&pageSize=99999").then(function(res) {
				this.allCoupons = res.body.data
				this.addDataList.coupons.forEach(add => {
					this.allCoupons.forEach(all => {
						if (add == all.id) {
							this.selectCoupon.push(all)
						}
					})
				})
			})
		},
		methods: {
			getjuan() {
				var s = "pageNum=" + this.filter.page + "&pageSize=" + this.filter.size;
				this.$http.get("dCoupon/list?" + s).then(function(res) {
					if (res.body.code == 200) {
						this.quanList = res.body.data
						this.filter.total = res.body.total
					}
				})
			},
			getCouponpackages() {
				var s = "pageNum=" + this.filter.page + "&pageSize=" + this.filter.size;
				this.$http.get("dCoupon/list?" + s).then(function(res) {
					if (res.body.code == 200) {
						this.packagesList = res.body.data
						this.filter.total = res.body.total
					}
				})
			},
			goback() {
				this.$router.go(-1)
			},
			handleClick() {
				if (this.$route.query.id != null) {
					this.addvolum(0)
					this.reload();
				} else {
					this.addCoupons = false
				}
			},
			handleCurrentChange(val) {
				this.filter.page = val
				this.getjuan()
			},
			handleSizeChange(val) {
				this.filter.size = val
				this.getjuan()
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}

	/deep/ .tabelContent .el-checkbox__label {
		display: none;
	}

	.add_botom {
		width: 100%;
		height: 50px;
	}

	.add_botom_nei {
		display: inline-block;
		float: right;
	}
</style>